import React, { createContext } from 'react'
import PropTypes from 'prop-types'
import { transformedProps } from '../helpers/ComponentHelper'

const { Provider, Consumer } = createContext()

const CMSComponents = ({ children, components }) => <Provider value={{ components }}>{children}</Provider>

const GetComponent = ({ citrus, type, ...props }) => {
  const componentProps = citrus ? transformedProps(citrus, type, props) : props

  return (
    <Consumer>
      {(context) => {
        if (!context || !context.components || !context.components[type]) return null
        return React.createElement(context.components[type], { type, ...componentProps })
      }}
    </Consumer>
  )
}

CMSComponents.propTypes = {
  children: PropTypes.object,
  components: PropTypes.object
}

export { GetComponent }
export default CMSComponents
